import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';

import { DEFAULT_CATALOG_SKU_EVENTS_LIMIT } from 'api/warehouse/catalogSkuEvents';
import { CatalogEventsTable } from 'components/catalog/components/catalogEvents/CatalogEventsTable';
import { ExternalSkuPicker } from 'components/procurement/components/purchaseOrdersV2/formComponents/ExternalSkuPicker';
import { useCatalogSkuEventsQuery } from 'shared/hooks/catalog/useCatalogSkuEventsQuery';

function CatalogEventsPage() {
    const [selectedExternalSku, setSelectedExternalSku] = useState('');

    const { data, error, isFetching, isLoading } = useCatalogSkuEventsQuery({
        enabled: !!selectedExternalSku,
        externalSku: selectedExternalSku,
        limit: DEFAULT_CATALOG_SKU_EVENTS_LIMIT,
    });

    useEffect(() => {
        if (error) {
            toast.error(`Failed to load item modification events: ${error.message}`);
        }
    }, [error]);

    const hasSelection = Boolean(selectedExternalSku);

    return (
        <div className="mt-4 flex flex-col gap-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
                <h2 className="text-lg font-semibold">Catalog Events</h2>
                <div className="w-full sm:max-w-md">
                    <ExternalSkuPicker value={selectedExternalSku} onValueChange={setSelectedExternalSku} />
                </div>
            </div>

            {!hasSelection ? (
                <p className="text-sm text-muted-foreground">
                    Select an external SKU to view item modification events.
                </p>
            ) : (
                <>
                    <div className="flex flex-col gap-1">
                        <h3 className="text-base font-semibold">SKU {data?.externalSku ?? selectedExternalSku}</h3>
                        {data?.name ? <p className="text-sm text-muted-foreground">{data.name}</p> : null}
                    </div>

                    <div className="flex flex-col gap-8">
                        <CatalogEventsTable
                            title="Item Master Modification Events"
                            data={data?.itemMasterEvents ?? []}
                            emptyMessage="No item master modification events found for this SKU."
                            isLoading={isLoading}
                            isFetching={isFetching}
                            limit={DEFAULT_CATALOG_SKU_EVENTS_LIMIT}
                            loadingMessage="Loading item master modification events…"
                            showItemMasterId
                        />
                        <CatalogEventsTable
                            title="Item Information Modification Events"
                            data={data?.itemInformationEvents ?? []}
                            emptyMessage="No item information modification events found for this SKU."
                            isLoading={isLoading}
                            isFetching={isFetching}
                            limit={DEFAULT_CATALOG_SKU_EVENTS_LIMIT}
                            loadingMessage="Loading item information modification events…"
                        />
                    </div>
                </>
            )}
        </div>
    );
}

export { CatalogEventsPage };
